<template>
  <div class="buttons-wrapper">
    <component
      v-if="floatingHandlers"
      v-for="(floatingHandler, index) in floatingHandlers"
      :key="index"
      :is="floatingHandler.component"
    />
    <v-slide-y-reverse-transition>
      <div v-show="showHandlers" class="handlers-menu">
        <component
          v-for="(handler, index) in handlers"
          :key="index"
          :is="handler.component"
          :class-cst="handler.classCst"
          :rules="handler.rules"
          :history="handler.history"
          :cloud-meta="handler.cloudMeta"
          :icon-button="handler.iconButton"
          :button="handler.button"
        />
      </div>
    </v-slide-y-reverse-transition>
    <button
      class="button-item-main"
      type="button"
      :aria-expanded="String(showHandlers)"
      aria-label="Otvoriť nástroje hypotéky"
      @click="showHandlers = !showHandlers"
    ><app-icon name="menu" :size="26" /></button>
  </div>
</template>

<script>
import DocumentCloudHandler from "../Popups/DocumentCloud/DocumentCloudHandler";
import CalculationsHistoryHandler from "../Popups/CalculationsHistory/CalculationsHistoryHandler";
import MetodicTable from "../Popups/CalculationsHistory/MetodicTable";
import ClientFinancingOfferHandler from "../Popups/ClientFinnancingOffer/ClientFinancingOfferHander.vue";
import MortgageAddHandler from "@/components/shared/PopupHandler/Popups/MortgageAdd/MortgageAddHandler.vue";
import ObjectsRemoveHandler from "@/components/shared/PopupHandler/Popups/ObjectsRemove/ObjectsRemoveHandler.vue";
import LimitsRefreshButton
  from "@/components/broker/KartaHypoteky/KartaHypotekyDetail/ApplicationChoice/LimitsRefreshButton.vue";
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "HandlersWrapperButton",
  components: {
    LimitsRefreshButton,
    ObjectsRemoveHandler,
    MortgageAddHandler,
    ClientFinancingOfferHandler,
    CalculationsHistoryHandler,
    DocumentCloudHandler,
    MetodicTable,
    AppIcon
  },
  props: {
    handlers: Array,
    floatingHandlers: [Array, null],
  },
  data: () => ({
    showHandlers: false,
  }),
}
</script>

<style lang="scss" scoped>
.buttons-wrapper { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; }
.handlers-menu { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; }
.button-item-main { border: 0; color: #fff; }
</style>
